import React from 'react'

import HELPTEXT from '../../../business-const/HelpText/HelpText'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    CardGridEstudo,
} from '../../../business-components/Card/Card'

import {
    tituloCliente,
    tituloConjuge,
} from '../cliente-form/ClienteService'

import {
    formataTableCellHeadExibeDadosTitulo,
    formataTableCellHeadExibeDadosTexto,
    formataTableCellHeadExibeDadosValor,
    formataTableCellHeadExibeDadosValorQuebraEspecial,
} from '../../../business-components/Formata/Formata'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    TableExibeDados,
    TableHeadExibeDados,
    TableRowHeadExibeDados,
    TableBodyExibeDados,
    TableRowBodyExibeDados,
    TableCellBodyExibeDados,
} from '../../../business-components/Table/TableExibeDados'

import {
    SvgIconComposicaoInventario,
} from '../../../business-components/SvgIcon/SvgIconEstudo/SvgIconEstudo'

import {
    dadosCompletosConjuge,
} from '../cliente-form/ClienteService'

import {
    relatorioModoApresentacao,
} from './EstudoService'

import {
    CardGridEstudoTabelaPadrao,
} from './EstudoComp'



const EstudoFormComposicaoInventario = ( { values, estudo, report, indInicial, indFinal, popup, gestaoPatrimonial } ) => {
    
    const ComposicaoInventario = ( /*props*/ ) => {

        const aumentoLetraCabecalho = 4
        const aumentoLetraReportCabecalho = values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato ? 2 : 4

        let headList = [
            {
                colSpan: 20,
                headTitle: formataTableCellHeadExibeDadosTitulo(LABEL.tipoInventario, report, null,
                    aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosTexto(LABEL.uf, report,
                    aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
            },
            {
                colSpan: 9,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.valor, report,
                    aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
            },
            {
                colSpan: 7,
                headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                    LABEL.percDespesasAdvocaticiasCustasJudiciaisQuebraEspecial, report,
                        aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
            },
            {
                colSpan: 4,
                headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(LABEL.percItcmdQuebraEspecial, report,
                    aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
            },
            {
                colSpan: 8,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.inventario, report,
                    aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
            },
            {
                colSpan: 8,
                headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                    LABEL.inventario + "<br/>" + tituloCliente(values), report,
                        aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
            },
        ]
    
        if (dadosCompletosConjuge(values)) {
            headList.push(
                {
                    colSpan: 8,
                    headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                        LABEL.inventario + "<br/>" + tituloConjuge(values), report,
                            aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
                },
            )
        }

        return (
            //<div
            //    {...props}
            //>
                <TableExibeDados
                    report={report}
                >
                    <TableHeadExibeDados
                        report={report}
                        //popup={popup}
                    >
                        <TableRowHeadExibeDados
                            dados={headList}
                        />
                    </TableHeadExibeDados>

                    <TableBodyExibeDados>
                        {estudo.current.inventario?.map((item, ind) => {
                            return !indFinal || (ind >= indInicial && ind <= indFinal) ? (
                                <TableRowBodyExibeDados
                                    key={ind}
                                    report={report}
                                >
                                    <TableCellBodyExibeDados
                                        colSpan={headList[0].colSpan}
                                        primeiraColuna={true}
                                    >
                                        {item.descricao}
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[1].colSpan}
                                    >
                                        {item.ufItcmd}
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[2].colSpan}
                                    >
                                        {item.valor}
                                    </TableCellBodyExibeDados>
                                    
                                    <TableCellBodyExibeDados
                                        colSpan={headList[3].colSpan}
                                    >
                                        {item.percDespesasAdvocaticiasCustasJudiciais}
                                    </TableCellBodyExibeDados>
                                    
                                    <TableCellBodyExibeDados
                                        colSpan={headList[4].colSpan}
                                    >
                                        {item.percItcmd}
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[5].colSpan}
                                    >
                                        {item.valorInventario}
                                    </TableCellBodyExibeDados>
                                    
                                    <TableCellBodyExibeDados
                                        colSpan={headList[6].colSpan}
                                    >
                                        {item.valorInventarioCliente}
                                    </TableCellBodyExibeDados>
                                    
                                    {dadosCompletosConjuge(values)
                                        ?
                                            <TableCellBodyExibeDados
                                                colSpan={headList[7].colSpan}
                                            >
                                                {item.valorInventarioConjuge}
                                            </TableCellBodyExibeDados>
                                        :
                                            <>
                                            </>
                                    }
                                </TableRowBodyExibeDados>
                            )
                            :
                            (
                                <TableRowBodyExibeDados
                                    key={ind}
                                    report={report}
                                />
                            )
                        })}
                    </TableBodyExibeDados>
                </TableExibeDados>
            //</div>
        )
    }

    const ComposicaoInventarioCardGrid = () => {

        return (
            <CardGridEstudoTabelaPadrao
                values={values}
                SvgIcon={SvgIconComposicaoInventario}
                label={LABEL.composicaoInventario}
                helpTextMorte={HELPTEXT.estudoInventarioMorte}
                helpTextInvalidez={HELPTEXT.estudoInventarioInvalidez}
                component={<ComposicaoInventario/>}
                popup={popup}
            />
        )
    }

    return (
        <DivForm>
            {report || relatorioModoApresentacao(values)
                ?
                    <ComposicaoInventario
                        //className={(!report && relatorioModoApresentacao(values) ? 'mt-10 ml-5 mr-5' : '')} // mudança da fonte: acrescentou mt-10
                    />
                :
                    gestaoPatrimonial
                        ?
                            <CardGridEstudo>
                                <ComposicaoInventarioCardGrid/>
                            </CardGridEstudo>
                        :
                            <ComposicaoInventarioCardGrid/>
                            
            }
        </DivForm>
    )
}

export default EstudoFormComposicaoInventario